import { render, staticRenderFns } from "./SelectionsSummary.vue?vue&type=template&id=ba918058"
import script from "./SelectionsSummary.vue?vue&type=script&lang=js"
export * from "./SelectionsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports